/**
 * App.js is modules critical for the app to run eg notifications appear everywhere. 
 */
export const Util = (function () {


    
    var getParameterByName = function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    var getPathParameterByName = function getParameterByName(name, url) {
      if (!url) url = window.location.pathname;
      var pathArray = url.split('/');
      if(pathArray.includes(name)){
        return pathArray[pathArray.indexOf(name)+1];
      };
      return null;
    }
    /** Functions that could be refactored to another module/class */
    function getCSRF(  ) {

      var csrf_name = document.getElementById('csrf_name');
      var csrf_value = document.getElementById('csrf_value');

      if(!csrf_name || !csrf_value) {
        throw Error("Error: No CSRF token present within form. Add CSRF")
      }
      
      var csrf_name_index = csrf_name.getAttribute('name');
      var csrf_value_index = csrf_value.getAttribute('name');
      var csrf = {};
      csrf[csrf_name_index] =  csrf_name.value
      csrf[csrf_value_index] =  csrf_value.value
      return JSON.stringify(csrf);
  }
    function toggleAlert(element, error, alert_class, fade_out_lengh = 2000) {
      $(element).removeClass(['alert-warning', 'alert-success']);
      $(element).html('');
      $(element).html(error);
      $([document.documentElement, document.body]).animate({
        scrollTop: $(element).offset().top
      }, 200);
      $(element).removeClass('d-none').fadeTo(2000, 500);
      if (fade_out_lengh != -1 ) {
        $(element).fadeOut(fade_out_lengh)
      }
      $(element).addClass(alert_class);
    }

    var index = {

        auth: function(){

            var error = Util.getParameterByName('error'); // "lorem"
          
            switch(error) {
              case "Password is incorrect.":
                $('.alert').append("Password Incorrect - please try again.");
                $('.alert').css("display", "")
                break;
              case "Following fields are missing or empty: password":
                $('.alert').append("Password field cannot be blank - please try again.");
                $('.alert').css("display", "")
                break;
            case "Following fields are missing or empty: mydexid":
                $('.alert').append("MydexID field cannot be blank - please try again.");
                $('.alert').css("display", "")
                break;
              case "Member does not exist.":
                $('.alert').append("Member does not exist - please try again.");
                $('.alert').css("display", "")
                break;
              default:
            }
        }
    }
    var encodeParam = function encodeParam(params) {
        var tagObject = {}
        var i = 0
        for (const value of params) {
            tagObject[`tag${i++}`] = value;
        }
        var queryString = $.param(tagObject)
        return queryString;
    }

    var convertDate = function (date) {
      
      var today = new Date(date * 1000);
      var date = ('0' + today.getDate()).slice(-2) + '/' +  ('0' + (today.getMonth()+1)).slice(-2) + '/' +  today.getFullYear();
      return date;
    }
    var convertTime = function (time) {
      return time.slice(0, -3); 
    }


    var disableFields = function(){

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      var forms = document.getElementsByClassName('disable');

      // Loop over them and prevent submission
      Array.prototype.filter.call(forms, function(form) {
          
          /**
           * Add a field to the required elements that on submit
           * validates.
           */
          var elements = form.elements; 
          Array.prototype.filter.call(elements, function(element) {
                element.setAttribute("disabled", true);
          });

      });
       
    },

    /**
     * Utility function to open a link in a new tab
     * @param {*} url 
     */
    openInNewTab = function (url) {
      window.open(url,'_blank','toolbar=1,menubar=1,location=1,status=1,scrollbars=1,noopener,noreferrer');
    }

    return {
        encodeParam:encodeParam,
        getParameterByName: getParameterByName,
        index:index,
        convertDate:convertDate,
        getPathParameterByName:getPathParameterByName,
        disableFields:disableFields,
        openInNewTab:openInNewTab,
        getCSRF:getCSRF,
        toggleAlert:toggleAlert,
    }

}());